import React, { FC } from "react";
import SectionButton from "./SectionButton";
import styles from "../../../styles/common/Profile.module.scss";
import { ISectionButtonProps } from "../../../models/account";

const SectionNavigation: FC<ISectionButtonProps> = ({ buttons }) => {
    return (
        <div className={styles.bottomCard}>
            {buttons.map((button, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <SectionButton key={index} {...button} />
            ))}
        </div>
    );
};

export default SectionNavigation;
